import {Model} from "@vuex-orm/core";
import SurveyElementAnswer from "./surveyElementAnswerModel";

export default class SurveyElement extends Model {

    static entity = 'survey_element';
    static primaryKey = 'id_survey_element';

    static fields() {
        return {
            id_survey_element: this.attr('new'),
            id_survey: this.attr(null),
            id_predecessor: this.attr(null),
            type: this.number(0),
            text: this.string(''),
            data: this.attr({}),
            mandatory: this.attr(false),
            options: this.attr(null),
            answers: this.hasMany(SurveyElementAnswer, 'id_survey_element', 'id_survey_element'),
        };
    }

    static getDefaultData(type) {
        switch (type) {
            case 0:
                return {
                    minLength: 0,
                    maxLength: 0,
                };
            case 1:
                return {
                    multiSelection: false,
                    hasCustomAnswer: false,
                };
            case 2:
                return {
                    count: 3,
                };
            case 3:
                return null;
        }
    }
}